
/**
 * Transliterate text
 * @param {*} string
 */
export const  translitraite = (string) => {
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

/**
 * Export validation
 */
export const errorValidation = {
	errorPlacement: function(error, element) {
		if (element.is(":checkbox")) {
			error.insertAfter(element.closest(".content-form-vacancy__row"));
		} else if (element.is(":radio")) {
			error.insertAfter(element.closest(".radio-label"));
		} else if (element.is(":file")) {
			error.insertAfter(element);
		} else {
			error.insertAfter(element);
		}
	},
	  highlight: (element) => {
			const $el = $(element);
		  if (!$el.hasClass('_error')) {
			  $el.addClass('_error');
		  }
		},
	unhighlight: (element) => {
		const $el = $(element);
		if ($el.hasClass('_error')) {
			$el.removeClass('_error');
		}
	},
	invalidHandler: function(form, validator) {

		console.log(validator);

		if (!validator.numberOfInvalids())
			return;

		$('html, body').animate({
			scrollTop: $(validator.errorList[0].element).offset().top - 80
		}, 1000);

	}
};
